import { useQuery } from 'react-query'
import { fetchExpertMentors } from '../apis/api.assignation'
import { useTeam } from '../pages/Team/Hooks/useTeam'
import { useMyCourse } from './ApiHooks/useCourses'

export const queryKeyHRExpertMentors = ['Expert Mentors', 'Status']

export const useHRExpertMentors = () => {
    const { courseID } = useTeam()
    const course = useMyCourse(courseID)

    const useMentor = course?.courseFlags.helpRequestType === 'mentor'

    const { data, ...rest } = useQuery({
        queryKey: queryKeyHRExpertMentors,
        queryFn: fetchExpertMentors,
        staleTime: 1000 * 60 * 3, // 3 minutes
        enabled: useMentor,
    })

    return { ...data, ...rest }
}
